/**
 * Gate around the client portal. Same auth check as ProtectedRoute,
 * plus a role check: only CLIENT users see the portal. Non-clients
 * who land here get bounced to the internal dashboard.
 */
import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';

export function PortalRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user?.role !== 'CLIENT') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
